import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface LogoutModalProps {
  open: boolean;
  onClose: () => void;
}

function LogoutModal({ open, onClose }: LogoutModalProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Logout</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to logout?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleLogout} variant="contained" color="primary">
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LogoutModal;